/* START CART DRAWER */
  
  var cartDrawer = true;
  var vVolumeDiscountEnabled = false && (30 > 0);

  function applyVolumeTierToContainer(containerId, tierKey) {
    var wrap = document.getElementById(containerId);
    if (!wrap) return;
    var nodes = wrap.querySelectorAll('[data-volume-tier]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].hidden = nodes[i].getAttribute('data-volume-tier') !== tierKey;
    }
  }

  window.syncPdpVolumePromoTier = function (itemCount) {
    if (!vVolumeDiscountEnabled) return;
    var n = parseInt(itemCount, 10);
    if (isNaN(n) || n < 0) n = 0;
    var tierKey = n <= 0 ? '0' : n === 1 ? '1' : '2';
    applyVolumeTierToContainer('pdp-volume-promo', tierKey);
    applyVolumeTierToContainer('top-bar-promo', tierKey);
    if (typeof window.applyPdpPriceDisplayFromActiveSize === 'function') {
      window.applyPdpPriceDisplayFromActiveSize(n);
    }
  };

  window.updateHeaderCartCount = function (itemCount, opts) {
    opts = opts || {};
    var n = parseInt(itemCount, 10);
    if (isNaN(n) || n < 0) n = 0;
    var el = document.getElementById('cartbannercount');
    var banner = document.getElementById('desktop-cart-banner');
    var mobileTop = document.getElementById('mobile-cartcount-top');
    var mobile = document.getElementById('mobile-cartcount');
    if (el) el.innerHTML = String(n);
    if (banner) {
      if (n === 0) banner.classList.add('is-hidden');
      else {
        banner.classList.remove('is-hidden');
        if (opts.animate) {
          banner.classList.remove('bounceInDown');
          void banner.offsetWidth;
          banner.classList.add('bounceInDown');
        }
      }
    }
    if (mobileTop) {
      mobileTop.innerHTML = String(n);
      if (n === 0) mobileTop.classList.add('cart-hidden');
      else {
        mobileTop.classList.remove('cart-hidden');
        if (opts.animate) {
          mobileTop.classList.remove('bounceInUp');
          void mobileTop.offsetWidth;
          mobileTop.classList.add('bounceInUp');
        }
      }
    }
    if (mobile) {
      mobile.innerHTML = String(n);
      if (n === 0) mobile.classList.add('cart-hidden');
      else {
        mobile.classList.remove('cart-hidden');
        if (opts.animate) {
          mobile.classList.remove('bounceInUp');
          void mobile.offsetWidth;
          mobile.classList.add('bounceInUp');
        }
      }
    }
    if (typeof window.syncHomeFeaturedPriceVisibility === 'function') {
      window.syncHomeFeaturedPriceVisibility(n);
    }
  };

   //TWITTER ADD TO CART
   // Twitter conversion tracking event code
    // Insert Twitter Event ID
    var lastClick = 0;
    var delay = 500;
    function twitterAddToCart(){
      if (lastClick >= (Date.now() - delay))
        return;
      lastClick = Date.now();
      var selectedSku = document.querySelector("#size-pick a.is-active");
      var currentPrice = selectedSku.getAttribute('data-vprice').replace("$","");
      twq('event', 'tw-oa74f-ode7f', {
        value: 1, // use this to pass the value of the conversion (e.g. 5.00)
        currency: 'USD', // use this to pass the currency of the conversion with an ISO 4217 code (e.g. ‘USD’)
        contents: [ // use this to pass an array of products or content
            // add all items to the array
            // use this for the first item
            {
              content_type: "",
              content_id: "",
              content_name: "",
              content_price: currentPrice,
              num_items: 1
            }], 
        email_address: "", // use this to pass a user’s email address
        phone_number: "" // phone number in E164 standard
      });
    }
    
  
  if(cartDrawer){

        window.getCartHtml = function(){
          fetch('/cart').then(function(response) {
            return response.text();
          }).then(function(data) {
            document.documentElement.classList.remove('v_gettingCart');
            window.updateAjaxCart(data);
          }).catch(function() {
            document.documentElement.classList.remove('v_gettingCart');
            console.log("error");
          });
        };
        window.updateVolumeUnlockBar = function(cartDOM){
          if(!vVolumeDiscountEnabled) return;
          var bar = document.querySelector('#v_volumeUnlockBar');
          if(!bar) return;
          var ctx = cartDOM ? cartDOM.querySelector('#cart-drawer-context') : null;
          var qty = ctx ? parseInt(ctx.getAttribute('data-cart-qty'), 10) : 0;
          if(isNaN(qty)) qty = 0;
          var textEl = bar.querySelector('.v_volumeUnlockBar__text');
          var track = bar.querySelector('.v_volumeUnlockBar__track');
          var fill = bar.querySelector('.v_volumeUnlockBar__fill');
          if(qty <= 0){
            bar.classList.add('is-hidden');
            bar.classList.remove('v_volumeUnlockBar--unlocked');
            bar.setAttribute('aria-hidden', 'true');
            window.syncPdpVolumePromoTier(0);
            return;
          }
          bar.classList.remove('is-hidden');
          bar.setAttribute('aria-hidden', 'false');
          if(qty === 1){
            bar.classList.remove('v_volumeUnlockBar--unlocked');
            if(textEl) textEl.innerHTML = 'Add 1 more item to unlock <strong>30% off</strong>';
            if(fill) fill.style.width = '50%';
            if(track){
              track.setAttribute('aria-valuenow', '50');
              track.setAttribute('aria-valuemax', '100');
              track.setAttribute('aria-label', 'Progress toward 30% off discount');
            }
          } else {
            bar.classList.add('v_volumeUnlockBar--unlocked');
            if(textEl) textEl.innerHTML = '<strong>30% off</strong> is unlocked on your cart!';
            if(fill) fill.style.width = '100%';
            if(track){
              track.setAttribute('aria-valuenow', '100');
              track.setAttribute('aria-valuemax', '100');
              track.setAttribute('aria-label', '30% off discount unlocked');
            }
          }
          window.syncPdpVolumePromoTier(qty);
        };
        window.updateAjaxCart = function(str){
          var cartDOM = document.createElement('div');
          cartDOM.innerHTML = str;
          //console.dir(cartDOM);
          var cartItems = cartDOM.querySelectorAll('.product-row');
          var ajaxCartItemsWrap = document.querySelector('#v_cartItems');
          var cartItemsTable = cartDOM.querySelector('#cartform table');
          var cartMsg = document.querySelector('#v_cartMsg');
          var subTotal = cartDOM.querySelector('#stotal');
          var origTotal = cartDOM.querySelector('#cart-original-total');
          var savingsTotal = cartDOM.querySelector('#ctotalsavings');
          var ajaxSavedEl = document.querySelector('#v_savedMessage');
          var ajaxTotalEl = document.querySelector('#v_subTotal');
          var ajaxOrigEl = document.querySelector('#v_cartOriginalTotal');
          var ajaxOrigWrap = document.querySelector('#v_cartOriginalPricingWrap');
          var cartBannerCount = document.querySelector('#cartbannercount');
          var ajaxShip = document.querySelector('#v_freeShipMsg');
          if(cartItems.length){
            document.documentElement.classList.remove('v_cartHasNoItems');
            var ctxQty = cartDOM.querySelector('#cart-drawer-context');
            var hq = ctxQty ? parseInt(ctxQty.getAttribute('data-cart-qty'), 10) : NaN;
            if (isNaN(hq) || hq < 0) {
              hq = 0;
              for (var _ri = 0; _ri < cartItems.length; _ri++) {
                var _qin = cartItems[_ri].querySelector('.qty_input');
                if (_qin) hq += parseInt(_qin.value, 10) || 0;
              }
            }
            if (hq < 1) hq = cartItems.length;
            if(ajaxCartItemsWrap && cartItemsTable){
              ajaxCartItemsWrap.innerHTML = '<table class="table is-fullwidth is-striped">'+cartItemsTable.innerHTML+'</table>';
              manageInsertedItemsToCart();
            }
            if(cartMsg){
              var drawerLabel = hq === 1 ? 'Item' : 'Items';
              cartMsg.innerHTML = hq + ' ' + drawerLabel + ' in your Cart';
            }
            if(subTotal && ajaxTotalEl){
              ajaxTotalEl.innerHTML = subTotal.innerHTML;
            }
            if(vVolumeDiscountEnabled){
              if(ajaxOrigEl){
                if(origTotal){
                  ajaxOrigEl.innerHTML = origTotal.innerHTML;
                  if(ajaxOrigWrap) ajaxOrigWrap.classList.remove('is-hidden');
                } else {
                  ajaxOrigEl.innerHTML = '';
                  if(ajaxOrigWrap) ajaxOrigWrap.classList.add('is-hidden');
                }
              }
              if(ajaxSavedEl && ajaxSavedEl.parentElement){
                if(savingsTotal && !savingsTotal.classList.contains('is-hidden')){
                  ajaxSavedEl.innerHTML = savingsTotal.innerHTML;
                  ajaxSavedEl.parentElement.classList.remove('is-hidden');
                } else {
                  ajaxSavedEl.innerHTML = '';
                  ajaxSavedEl.parentElement.classList.add('is-hidden');
                }
              }
            } else {
              if(ajaxOrigEl) ajaxOrigEl.innerHTML = '';
              if(ajaxOrigWrap) ajaxOrigWrap.classList.add('is-hidden');
              if(ajaxSavedEl && ajaxSavedEl.parentElement){
                ajaxSavedEl.innerHTML = '';
                ajaxSavedEl.parentElement.classList.add('is-hidden');
              }
            }
            if(ajaxShip){
              ajaxShip.innerHTML = '';
            }
            window.updateVolumeUnlockBar(cartDOM);
            window.updateHeaderCartCount(hq);
            if (window.applyBuy2DrawerPrices) window.applyBuy2DrawerPrices();
          } else {
            document.documentElement.classList.add('v_cartHasNoItems');
            ajaxCartItemsWrap.innerHTML = '<div class="v_cartNoMsg has-text-centered"><h2>Your cart is currently empty.</h2><a href="/" class="button is-primary">Continue Browsing</a></div>';
            if(cartMsg){
              cartMsg.innerHTML = '0 Item in your Cart';
            }
            if(ajaxShip){
              ajaxShip.innerHTML = '';
            }
            if(ajaxSavedEl && ajaxSavedEl.parentElement){
              ajaxSavedEl.innerHTML = '';
              ajaxSavedEl.parentElement.classList.add('is-hidden');
            }
            if(ajaxOrigEl) ajaxOrigEl.innerHTML = '';
            if(ajaxOrigWrap) ajaxOrigWrap.classList.add('is-hidden');
            window.updateVolumeUnlockBar(null);
            window.updateHeaderCartCount(0);
            if (window.applyBuy2DrawerPrices) window.applyBuy2DrawerPrices();
          }
        };
        window.manageInsertedItemsToCart = function(){
          var insertedItems = document.querySelectorAll('#v_cartItems .product-row');
          if(insertedItems.length){
            insertedItems.forEach(function(itm){
              var removeBtn = itm.querySelector('.control a[href*="/cart/change"]');
              var totalCol = itm.querySelector('td[data-label="Total"]');
              var qty = itm.querySelector('td[data-label="QTY"] > .field');
              var prodNameCol = itm.querySelector('td[data-label="Product"] + td');
              var varId = itm.getAttribute('data-sku');
              var plusBtn = itm.querySelector('.plus_prod');
              var minusBtn = itm.querySelector('.minus_prod');
              if(removeBtn && !itm.querySelector('.v_removeBtn')){
                totalCol.insertBefore(removeBtn, totalCol.children[0]);
                removeBtn.classList.add('v_removeBtn');
                removeBtn.setAttribute("aria-label", "Remove Product");
                removeBtn.setAttribute('onclick', 'return removeThisItemFromCart('+varId+',event)');
              }
              if(qty && prodNameCol && !itm.querySelector('.v_qtyWrap')){
                prodNameCol.appendChild(qty);
                qty.classList.add('v_qtyWrap');
              }
              if(plusBtn){
                plusBtn.onclick = function(){
                  var qtyInput = itm.querySelector('.qty_input');
                  if(qtyInput){
                    var qtyValue = qtyInput.value;
                    qtyValue++;
                    qtyInput.value = qtyValue;
                    document.documentElement.classList.add("v_processingCart");
                    updateItemsInCart(varId,qtyValue);
                  }
                };
              }
              if(minusBtn){
                minusBtn.onclick = function(){
                  var qtyInput = itm.querySelector('.qty_input');
                  if(qtyInput){
                    var qtyValue = qtyInput.value;
                    if(qtyValue > 1){
                      qtyValue--;
                      qtyInput.value = qtyValue;
                      document.documentElement.classList.add("v_processingCart");
                      updateItemsInCart(varId,qtyValue);
                    }
                  }
                };
              }
            });
          }
        };
        window.openCartDrawer = function(e){
          if(e){
            e.preventDefault();
            e.stopPropagation();
          }
          document.documentElement.classList.add("v_cartOpened");
          if(!document.documentElement.classList.contains('v_gettingCart')){
            document.documentElement.classList.add('v_gettingCart');
            getCartHtml();
          }
          document.querySelector('.v_cartDrawer').setAttribute("aria-hidden","false");
          document.querySelector('.v_cartDrawer').classList.remove("is-hidden");
          trapFocus();
          return;
        };
        window.closeCartDrawer = function(){
          document.documentElement.classList.remove("v_cartOpened");
          document.querySelector('.v_cartDrawer').setAttribute("aria-hidden","true");
          document.querySelector('.v_cartDrawer').classList.add("is-hidden");
        };
        window.removeThisItemFromCart = function(variant,e){
          e.preventDefault();
          e.stopPropagation();
          document.documentElement.classList.add("v_processingCart");
          updateItemsInCart(variant,0);
          return;
        };
        window.updateItemsInCart = function(variant, qty){
          document.documentElement.classList.add("v_processingCart");
          document.documentElement.classList.add('v_gettingCart');
          fetch('/cart/change.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "id": variant.toString(),
              "quantity": qty
            })
          }).then(response => response.json()).then(data => {
            if (typeof window.v_markRecentCartActivityForHomeReminder === 'function') {
              window.v_markRecentCartActivityForHomeReminder();
            }
            if (typeof data.item_count === 'number') {
              window.updateHeaderCartCount(data.item_count);
              window.syncPdpVolumePromoTier(data.item_count);
            }
            window.getCartHtml();
            document.documentElement.classList.remove('v_processingCart');
          }).catch((error) => {
            document.documentElement.classList.remove('v_processingCart');
            document.documentElement.classList.remove('v_gettingCart');
          });
        };
        (function eightees4605v1(){
          if(document.querySelectorAll('.top-cart[href="/cart"]').length && !document.querySelectorAll('.eightees4605v1').length){
            addCartDrawer();
            overridecartclick();
            getCartHtml();
            addCartCTAClick();
            var send = XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.send = function() { 
              this.addEventListener('load', function() {
                overridecartclick();
                addCartCTAClick();
              });
              return send.apply(this, arguments);
            };
            document.body.classList.add('eightees4605v1');
          } else if(!document.querySelectorAll('.eightees4605v1').length) {
            requestAnimationFrame(eightees4605v1);
          }
          function addCartDrawer(){
            
          }
          function overridecartclick(){
            const cartLinks = document.querySelectorAll('a[href="/cart"]');
            if(cartLinks.length){
              cartLinks.forEach(function(cl){
                cl.setAttribute('onclick', 'return openCartDrawer(event);');
              });
            }
          }
          function addCartCTAClick(){
            var cartBtn = document.querySelector('#cart-button');
            var qtyIncrease = document.querySelector('#buy-wrap #add');
            var qtyDecrease = document.querySelector('#buy-wrap #subtract');
            //for add to cart on pdp
            if(cartBtn){
              cartBtn.addEventListener('click', function(){
                var hiddenInterval = setInterval(function(){
                  if(cartBtn.classList.contains('is-hidden')){
                    openCartDrawer();
                    clearInterval(hiddenInterval);
                    twitterAddToCart();
                  } else {
                    setTimeout(function(){
                      clearInterval(hiddenInterval);
                    },6000);
                  }
                },10);
              }); 
            }
            //for quantity + - on pdp
            if(qtyIncrease){
              qtyIncrease.addEventListener('click', function(){
                var waveFinder = setInterval(function(){
                  if(!qtyIncrease.querySelector('.wave')){
                    openCartDrawer();
                    clearInterval(waveFinder);
                  } else {
                    setTimeout(function(){
                      clearInterval(waveFinder);
                    },6000);
                  }
                },10);
              }); 
            }
            if(qtyDecrease){
              qtyDecrease.addEventListener('click', function(){
                var cartQtyEl = document.querySelector('#cartbannercount');
                var cartQty = cartQtyEl.innerText;
                if(+cartQty >= 2){
                  var waveFinderSub = setInterval(function(){
                    if(!qtyDecrease.querySelector('.wave')){
                      openCartDrawer();
                      clearInterval(waveFinderSub);
                    } else {
                      setTimeout(function(){
                        clearInterval(waveFinderSub);
                      },6000);
                    }
                  },10);
                }
              }); 
            }
          }
        })();



function trapFocus(){
  var  focusableElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var vCartDrawer = document.querySelector('.v_cartContainer');
  var firstFocusableElement = vCartDrawer.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
  var focusableContent = vCartDrawer.querySelectorAll(focusableElements);
  var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
  
  document.addEventListener('keydown', trappedFocus);
    
  function trappedFocus(e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (event.keyCode === 13) {
      if(e.target.classList.contains('v_cartCloser')){
         window.closeCartDrawer();
      }
    }else if (event.keyCode === 27){
       window.closeCartDrawer();
    }
    
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  };
  firstFocusableElement.focus();
}


}
  /* END CART DRAWER */
  